<template>
    <div
        class="site-selector"
        :class="[{ 'is-open': isOpen }]"
        v-if="data && data.length > 1">
        <button
            class="site-selector__trigger"
            @click="toggleOpenedState">
            <z-link
                :href="getUrl(currentLang)"
                :size="size"
                theme="light"
                icon="arrows/caret"
                icon-position="right"
                dir="down">
                <span v-html="currentLang.lang"></span>
            </z-link>
        </button>
        <div class="site-selector__dropdown">
            <template
                v-for="item in data"
                :key="item.lid">
                <z-link
                    class="site-selector__link"
                    v-if="!item.active"
                    :title="item.title"
                    :href="getUrl(item)"
                    size="s"
                    theme="light">
                    <span v-html="item.lang"></span>
                </z-link>
            </template>
        </div>
    </div>
</template>

<script setup>
import { useGetter } from '@/composable/useGetter'
import { computed, ref } from 'vue'

defineProps({
    size: {
        type: String,
        default: 's',
        comment: 'Размер текста из токенов'
    }
})

const { app } = useGetter(['app'])
const data = app.value.components['site-selector']
const isOpen = ref(false)

const getUrl = (item) => {
    if (item.dir) {
        const dir = item.dir.slice(0, -1)
        return dir ? `${dir}${item.url}` : `${item.host}${dir}${item.url}`
    }
    return '/'
}

const toggleOpenedState = () => {
    isOpen.value = !isOpen.value
}

const currentLang = computed(() => {
    return data.find((item) => item.active)
})
</script>

<style lang="scss">
.site-selector {
    $parent: &;
    position: relative;

    &.is-open {
        #{$parent}__dropdown {
            display: block;
        }

        .z-link__icon {
            transform: rotate(0);
        }
    }

    &__trigger {
        background: none;
        border: none;
        padding: 7px 16px;
        border-radius: 50px;
        background-color: rgba(255, 255, 255, 0.2);

        .z-link {
            pointer-events: none;
            display: block;
            width: max-content;
            text-decoration: none !important;
            font-weight: 500;
            text-transform: capitalize;

            @include breakpoint(mobile) {
                padding-right: 0;
            }

            &__text {
                font-size: 20px;
                line-height: 1.3;
            }
        }

        .z-icon {
            width: 20px;
            height: 20px;
            margin-left: 4px;

            @include breakpoint(mobile) {
                display: none;
                margin-left: 0;
            }
        }
    }

    &__dropdown {
        display: none;
        position: absolute;
        left: 0;
        top: calc(100% + 8px);
        z-index: 3;
        right: 0;
        border-radius: 20px;
        overflow: hidden;
    }

    &__link {
        padding: 7px 16px;
        display: block;
        width: 100%;
        font-size: 20px;
        font-weight: 500;
        color: var(--color-black-80);
        text-transform: capitalize;
        text-decoration: none !important;
        background-color: var(--color-surface-container);
        transition: background-color 0.25s ease-out, color 0.25s ease-out;

        &:hover {
            background-color: var(--color-surface-dim-secondary);
            color: var(--color-link-hover);
        }

        &:active {
            background-color: var(--color-surface-dim-primary);
            color: var(--color-link-active);
        }

        &.is-active {
            pointer-events: none;
            opacity: 0.6;
        }
    }
}
</style>
